import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import SlotifyLogo from "@/components/SlotifyLogo";
import { useLanguage } from "@/contexts/LanguageContext";

const PrivacyPolicy = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card">
        <div className="container mx-auto flex h-16 items-center justify-between px-4">
          <Link to="/" className="flex items-center gap-2">
            <SlotifyLogo className="h-7" />
          </Link>
          <Button variant="ghost" size="sm" asChild>
            <Link to="/">
              <ArrowLeft className="mr-2 h-4 w-4" />
              {t("legal.back_home")}
            </Link>
          </Button>
        </div>
      </header>

      <main className="container mx-auto max-w-3xl px-4 py-12">
        <h1 className="text-3xl font-bold text-foreground mb-2">{t("legal.privacy_title")}</h1>
        <p className="text-sm text-muted-foreground mb-8">{t("legal.last_updated")}: 15 February 2026</p>

        <div className="prose prose-sm max-w-none text-foreground space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-3">{t("privacy.intro_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("privacy.intro_text")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">{t("privacy.data_collect_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("privacy.data_collect_text")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">{t("privacy.data_use_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("privacy.data_use_text")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">{t("privacy.cookies_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("privacy.cookies_text")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">{t("privacy.sharing_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("privacy.sharing_text")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">{t("privacy.retention_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("privacy.retention_text")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">{t("privacy.rights_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("privacy.rights_text")}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">{t("privacy.contact_title")}</h2>
            <p className="text-muted-foreground leading-relaxed">{t("privacy.contact_text")}</p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
